module.exports = __webpack_public_path__ + "img/edge_patrimoine_musee.8745d0ea.svg";